import React from 'react';
import { useTranslation } from 'react-i18next';
import { PropertyPanelsProps } from './PropertyPanels';
import { CTALink } from '../../shared/CTALink/CTALink';
import { ContentfulImage } from '../../Contentful';
import { images } from '../../shared/assets';

const RestaurantPanel: React.FC<PropertyPanelsProps> = ({ property }) => {

  const { t } = useTranslation();

  const toCamelCase = (str: string): string => {
    return str.split('-')
      .map((part, index) => {
        if (index === 0) {
          return part;
        }
        return part.charAt(0).toUpperCase() + part.slice(1);
      })
      .join('');
  }

  const getContentForProperty = () => {
    switch (property.toLowerCase()) {
      case 'iguazu':
        return {
          title: t('properties/iguazu:intro.expandedDescription'),
          description: t('properties/iguazu:intro.extraDescription'),
          cta: t('properties/iguazu:intro.seeOurLodgesButton')
        };
      case 'mendoza':
        return {
          title: t('properties/mendoza:intro.expandedDescription'),
          description: t('properties/mendoza:intro.extraDescription'),
          cta: t('properties/mendoza:intro.seeOurLodgesButton'),
        };
      case 'santa-catarina':
      case 'santacatarina':
        return {
          title: t('properties/santa-catarina:intro.expandedDescription'),
          description: t('properties/santa-catarina:intro.extraDescription'),
          cta: t('properties/santa-catarina:intro.lodgesCta'),
        };
      case 'atacama':
        return {
          title: t('properties/atacama:intro.paragraph2'),
          description: t('properties/atacama:intro.paragraph3'),
          cta: t('properties/atacama:intro.cta'),
        };
      case 'patagonia':
      default:
        return {
          title: t('properties/patagonia:intro.expandedDescription'),
          description: t('properties/patagonia:intro.extraDescription'),
          cta: t('properties/patagonia:intro.seeOurLodgesButton'),
        };
    }
  };

  const content = getContentForProperty();

  const showLinks = false;

  return (
    <div className="restaurant-panel">
      <div className="restaurant-panel__media">
        <ContentfulImage
          imageKey="restaurant-panel"
          fallbackSrc={images.propertyCarouselImages[toCamelCase(property)]?.restaurantBanner || images.restaurantBanner}
          alt="Restaurant"
        />
      </div>
      <div className="restaurant-panel__content">
        <h2 className='restaurant-panel__heading'>{content.title}</h2>
        <div className="restaurant-panel__description">
          <p>{content.description}</p>
          {
            showLinks &&
            <CTALink
              text={content.cta}
              href="/destinations"
              type="secondary"
              color="awasi"
            />
          }
        </div>
      </div>
    </div>
  );
};

export default RestaurantPanel;
